import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function Instagram({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <defs>
                <radialGradient id="instagram" cx="0%" cy="100%" r="100%" fx="0%" fy="100%">
                    <stop offset="10%" style={{stopColor: '#FFDD55'}}/>
                    <stop offset="50%" style={{stopColor: '#FF543E'}}/>
                    <stop offset="100%" style={{stopColor: '#C837AB'}}/>
                </radialGradient>
            </defs>
            <path fill={"url(#" + FillColor + ")"}
                d="M16.48 2H7.52A5.526 5.526 0 0 0 2 7.52v8.96A5.525 5.525 0 0 0 7.52 22h8.96A5.526 5.526 0 0 0 22 16.48V7.52A5.526 5.526 0 0 0 16.48 2zm3.746 14.48a3.75 3.75 0 0 1-3.745 3.745H7.519a3.749 3.749 0 0 1-3.744-3.744V7.519a3.749 3.749 0 0 1 3.744-3.744h8.962a3.75 3.75 0 0 1 3.744 3.744v8.962z"/>
            <path fill={"url(#" + FillColor + ")"}
                d="M12 6.847A5.16 5.16 0 0 0 6.847 12 5.16 5.16 0 0 0 12 17.154 5.16 5.16 0 0 0 17.154 12 5.16 5.16 0 0 0 12 6.847zm0 8.532A3.383 3.383 0 0 1 8.621 12a3.383 3.383 0 0 1 3.38-3.379 3.383 3.383 0 0 1 3.378 3.38A3.383 3.383 0 0 1 12 15.378zM17.37 5.342a1.306 1.306 0 0 0-1.302 1.301c0 .342.14.678.383.92.24.242.577.382.919.382.343 0 .677-.14.92-.381.242-.243.381-.579.381-.92 0-.344-.139-.68-.381-.921a1.307 1.307 0 0 0-.92-.38z"/>
        </svg>
    )
}
